import React, { CSSProperties, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import toast from "react-hot-toast";
import { If } from "@/components/custom/condition";
import { IconCopyOutline } from "@/components/icons";

interface Props {
  text: string | number;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  role?: string;
  onClick?: () => void;
  positionIcon?: "start" | "end";
  classNameIcon?: string;
  colorIconDefault?: string;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
}

export function ButtonCopy(data: Props) {
  const {
    text,
    children,
    role = "button",
    onClick = () => {},
    positionIcon = "",
    colorIconDefault,
    classNameIcon = "",
    className = "",
    onMouseEnter,
    onMouseLeave,
    ...props
  } = data;

  const copy = (text: string) => {
    if (text) {
      onClick();
      navigator?.clipboard?.writeText(text);
      toast.success('Sao chép thành công"');
    }
  };

  return (
    <div
      {...props}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      onClick={(e) => {
        e?.stopPropagation();
        copy(text?.toString());
      }}
      role={role}
      className={`hover:text-primary focus:text-primary fo group inline-flex items-center gap-1 ${className}`}
    >
      <If
        condition={positionIcon === "start"}
        Then={
          <>
            <IconCopyOutline
              color={colorIconDefault}
              className={twMerge("block group-hover:hidden", classNameIcon)}
            />
            <IconCopyOutline
              className={twMerge("group-hover:block hidden", classNameIcon)}
              color="#F80"
            />
          </>
        }
      />
      {children}
      <If
        condition={positionIcon === "end"}
        Then={
          <>
            <IconCopyOutline
              color={colorIconDefault}
              className={twMerge("block group-hover:hidden", classNameIcon)}
            />
            <IconCopyOutline
              className={twMerge("group-hover:block hidden", classNameIcon)}
              color="#F80"
            />
          </>
        }
      />
    </div>
  );
}
